import { createClient } from '@supabase/supabase-js'

export const createSupabaseClient = () => {
  return createClient(Penmate.env.supabaseUrl, Penmate.env.supabaseKey)
}
// Create a single supabase client for interacting with your database
